const fieldLibrary = {
  title: "ספריית שדות",
  fields: "שדות",
  templates: "תבניות",
  styles: "סגנונות",
  search: "חיפוש שדה...",
  noResults: "לא נמצאו שדות",
  expandPanel: "הצג במצב מלא",
  categoryText: "טקסט",
  categorySelection: "בחירה",
  categoryTime: "זמן",
  configTitle: "הגדרות שדה",
  label: "תווית",
  placeholder: "טקסט ברירת מחדל",
  required: "חובה",
  maxLength: "אורך מקסימלי",
  defaultValue: "ערך ברירת מחדל",
  defaultChecked: "מסומן כברירת מחדל",
  options: "אפשרויות",
  addOption: "הוסף אפשרות",
  maxSelections: "מקסימום בחירות",
  format: "פורמט",
  allowCustomTags: "אפשר תגיות חופשיות",
  maxTags: "מקסימום תגיות",
  addTag: "הוסף תגית",
  save: "שמור",
  cancel: "ביטול",
  saving: "שומר...",
  soon: "בקרוב",
  existingFields: "שדות קיימים",
  createNew: "שדה חדש",
  usageCount: "שימושים",
  usedIn: "משמש ב:",
  noDefinitions: "אין שדות מוגדרים עדיין. צור שדה חדש בלשונית ״שדה חדש״.",
  insertField: "הכנס שדה",
  editDefinition: "ערוך הגדרה",
  deleteDefinition: "מחק שדה",
  confirmDelete: "בטוח למחוק? השדה משמש ב-{count} מסמכים.",
  lastEdited: "נערך לאחרונה",
  dropdownMode: "מצב קטן",
  floatingMode: "חלון צף",
  loading: "⏳ טוען...",
} as const;
export default fieldLibrary;
